const EmbeddedComponents = require('@/vue/EmbeddedComponents');
const EventNames = require('@/lib/Events/EventNames');
const PaymentMethodRef = require('@/lib/PaymentMethods/PaymentMethodRef');

/**
 * @param $filter
 * @param $scope
 */
function TescoVoucherUkPaymentCtrl(
    $filter,
    $scope,
) {
    const thisPaymentMethodRef = PaymentMethodRef.TESCO_VOUCHER_UK;

    $scope.$on('$destroy', () => {
        window.rootVueStore.commit('removeActiveEmbeddedComponent', EmbeddedComponents.TESCO_VOUCHER_UK_PAYMENT_METHOD_COMPONENT);
    });

    $scope.$on(EventNames.PAYMENT_METHOD_CHANGED, function (event, newPaymentMethod) {
        const newPaymentMethodRef = newPaymentMethod?.ref;
        if (newPaymentMethodRef === thisPaymentMethodRef) {
            window.rootVueStore.commit('addActiveEmbeddedComponent', { name: EmbeddedComponents.TESCO_VOUCHER_UK_PAYMENT_METHOD_COMPONENT });
        } else {
            window.rootVueStore.commit('removeActiveEmbeddedComponent', EmbeddedComponents.TESCO_VOUCHER_UK_PAYMENT_METHOD_COMPONENT);
        }
    });
}

module.exports = TescoVoucherUkPaymentCtrl;
